import { apiGet, apiPost, apiDelete, apiPut } from 'api';
import { SentenceType } from 'types';

const sentence = {
  get: async (id: number) => {
    const data = await apiGet(`${process.env.REACT_APP_API_URI}/api/sentence/${id}`);
    return data;
  },
  create: async (fileId: number, sentence: SentenceType) => {
    sentence.FileId = fileId;
    // var body = {
    //     Id : fileId,
    //     Description : sentence.Description,
    //     sentence.
    // }
    const data = await apiPost(`${process.env.REACT_APP_API_URI}/api/sentence/create`, sentence);
    return data;
  },
  update: async (fileId: number, sentence: string) => {
    var body = {
        Id : fileId,
        Description : sentence
    }
    const data = apiPut(`${process.env.REACT_APP_API_URI}/api/sentence/update`, body);
    return data;
  },
  delete: async (sentenceId: number) => {
    const data = await apiDelete(`${process.env.REACT_APP_API_URI}/api/sentence/delete/${sentenceId}`);
    return data;
  }
};

export default sentence;
